import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isSameDay } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';
import { KeyboardDatePicker, MenuItem, Select } from 'seagull';
import { BillMode } from '~/components/BillClientModal/BillClientModal.types';
import { getDefaultIssueDate, getMaxDateMessage, getMinDateMessage, normalizeEffectiveDate, selectorWidth } from '~/components/BillClientModal/BillingDate/BillingDate.utils';
import { useIssueDateValidation } from '~/components/BillClientModal/BillingDate/useIssueDateValidation';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
import { connectControllerToKeyboardDatePicker } from '~/utils/react-hook-form.utils';
import styles from './BillingDate.module.scss';
const BillingDate = (param)=>{
    let { billModeOptions, invoiceDateInfo, effectiveDate = null, earliestBillableDate } = param;
    const { t: texts } = useLocaleKeys('components.billingDate');
    const { getNow } = useIoContext();
    const { control, watch, setValue, trigger } = useFormContext();
    const [mode] = watch([
        'mode'
    ]);
    const { minDate, maxDate, validationRules } = useIssueDateValidation({
        mode,
        effectiveDate,
        earliestBillableDate
    });
    // force re-validation when mode changes to ensure Material-UI component updates its internal state and does not preserve the error state
    useEffect(()=>{
        trigger('issueDate');
    }, [
        mode,
        trigger
    ]);
    const onBillModeChange = (value)=>{
        const newIssueDate = getDefaultIssueDate(value, invoiceDateInfo, getNow(), normalizeEffectiveDate(effectiveDate), earliestBillableDate);
        setValue('issueDate', newIssueDate, {
            shouldValidate: true
        });
    };
    const highlightDay = invoiceDateInfo && mode === BillMode.FutureDate ? (day)=>invoiceDateInfo.invoiceDraftDates.dates().some((d)=>isSameDay(day, d)) : undefined;
    const testId = mode === BillMode.FutureDate ? 'manual-bill-future-date' : 'manual-bill-issue-date';
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modeRow,
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: 'mode',
                render: (renderProps)=>/*#__PURE__*/ _jsx(Select, {
                        bi: {
                            name: 'bill_mode'
                        },
                        collapseHelperText: false,
                        width: selectorWidth,
                        value: mode,
                        label: texts.label(),
                        testId: "manual-bill-mode",
                        children: billModeOptions.map((param)=>{
                            let { value, text, disabled, tooltip } = param;
                            return /*#__PURE__*/ _jsx(MenuItem, {
                                value: value,
                                disabled: disabled,
                                tooltipProps: tooltip ? {
                                    placement: 'top',
                                    title: tooltip
                                } : undefined,
                                testId: "mode-".concat(value),
                                onClick: ()=>{
                                    onBillModeChange(value);
                                    renderProps.field.onChange(value);
                                },
                                children: text
                            }, value);
                        })
                    })
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "issueDate",
                rules: validationRules,
                render: (props)=>/*#__PURE__*/ _jsx(KeyboardDatePicker, _object_spread_props(_object_spread({
                        bi: {
                            name: 'billing_issue_date'
                        },
                        disabled: mode === BillMode.Upcoming,
                        testId: testId,
                        style: {
                            width: selectorWidth
                        },
                        minDate: minDate,
                        maxDate: maxDate,
                        minDateMessage: getMinDateMessage(minDate),
                        maxDateMessage: getMaxDateMessage(maxDate)
                    }, connectControllerToKeyboardDatePicker(props)), {
                        highlightDay: highlightDay
                    }))
            })
        ]
    });
};
export default BillingDate;
